module.exports = __webpack_public_path__ + "static/media/greenhouse-2.93d4c54d.svg";